import React, { useState } from 'react'

import { useInView } from 'react-cool-inview'

import { string } from 'prop-types'

function ModelWithImage({ name, imageUrl, imageAlt = '' }) {
  const [isVisible, setIsVisible] = useState(false)

  const { observe } = useInView({
    rootMargin: '50px',
    unobserveOnEnter: true,
    onEnter: () => {
      setIsVisible(true)
    },
  })

  return (
    <div className="model-info" ref={observe}>
      <div className="model-info__thumbnail">
        {isVisible && (
          <img
            src={imageUrl}
            alt={imageAlt}
            className="model-info__image"
            loading="lazy"
            decoding="async"
          />
        )}
      </div>
      <span className="model-info__name">{name}</span>
    </div>
  )
}

ModelWithImage.propTypes = {
  name: string.isRequired,
  imageUrl: string.isRequired,
  imageAlt: string,
}

export default ModelWithImage
